'use client';
import React from 'react';
import get from 'lodash/get';
import CategoryNewsBlockHome from './CategoryNewsBlockHome';

const Activity2Columns = ({ postsByShowcaseWalls, websiteCode, deviceType }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-2 md:px-4">
      {get(postsByShowcaseWalls, 'results', [])
        .slice(0, 2)
        .map((item) => (
          <CategoryNewsBlockHome key={item.slug} item={item} slug="tin-tuc" websiteCode={websiteCode} deviceType={deviceType} />
        ))}
    </div>
  );
};

export default Activity2Columns;
